export default __webpack_public_path__ + "static/media/arrow-narrow-down (1).1fba13ed.svg";